import { render, staticRenderFns } from "./fbp.vue?vue&type=template&id=672c4dc4&scoped=true"
import script from "./fbp.vue?vue&type=script&lang=js"
export * from "./fbp.vue?vue&type=script&lang=js"
import style0 from "./fbp.vue?vue&type=style&index=0&id=672c4dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c4dc4",
  null
  
)

export default component.exports